export default "__VITE_ASSET__Cnal5R0F__"